<template>
  <v-card flat class="v-card__container">
    <v-row class="d-flex align-center">
      <v-col>
        <h4 class="mb-0">Aktuella Ärenden</h4>
      </v-col>
      
      <v-col class="d-flex align-center">
        <v-switch 
          v-model="myErrandsAreVisible"
          class="mb-0 ml-auto d-inline-block" 
          label="Hanterade ärenden"
          hide-details
          :disabled="isLoading"
          :loading="isLoading"
        ></v-switch>
      </v-col>
    </v-row>

    <Orders v-if="canSeeOrders" />

    <Applications />
    <BasicEducationCertificates />
    <WidgetQualificationTime />
    <WidgetTradeCertificate />
    <MachinePermission />
    <InstructorExemption />
    <OtherCases />
    <PrintOrders />
    <template v-if="!handledCasesAreVisible">
      <CompaniesWithoutAgreement />
      <CompaniesWithoutEmployees />
    </template>
  </v-card>
</template>

<script>
import Applications from '@/components/widgets/Applications'
import CompaniesWithoutEmployees from '@/components/widgets/CompaniesWithoutEmployees'
import BasicEducationCertificates from '@/components/widgets/BasicEducationCertificates'
import Orders from '@/components/widgets/Orders'
import WidgetTradeCertificate from '@/components/widgets/TradeCertificates'
import MachinePermission from '@/components/widgets/MachinePermission'
import InstructorExemption from '@/components/widgets/InstructorExemption'
import OtherCases from '@/components/widgets/OtherCases'
import PrintOrders from '@/components/widgets/PrintOrders'
import WidgetQualificationTime from '@/components/widgets/WidgetQualificationTime'
import {mapGetters, mapActions} from 'vuex'
import {CanIDo} from '@/components/mixins'
import CompaniesWithoutAgreement from '@/components/widgets/CompaniesWithoutAgreement.vue'

// @group Common
// Welcome component
export default {
  name: 'Welcome',
  
  mixins: [CanIDo],

  components: {
    Applications,
    CompaniesWithoutEmployees,
    Orders,
    WidgetTradeCertificate,
    MachinePermission,
    InstructorExemption,
    BasicEducationCertificates,
    OtherCases,
    PrintOrders,
    OtherCases,
    WidgetQualificationTime,
    CompaniesWithoutAgreement
  },

  watch: {
    myErrandsAreVisible: {
      handler(value) {
        if ( value )
          this.setHandledCases(value)
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'handledCasesAreVisible']),
    ...mapGetters('app', ['isLoading']),

    myErrandsAreVisible: {
      get() {
        return localStorage.getItem('my-errands-view') || this.handledCasesAreVisible
      },
      set(value) {
        this.setHandledCases(value)
      }
    }
  },

  asyncComputed: {
    canSeeOrders(){
      return this.canIDo('admin', 'list');
    },
  },

  methods: {
    ...mapActions('currentuser', ['setHandledCases'])
  }
}
</script>

<style scoped>
</style>
